import { render, staticRenderFns } from "./article-table.vue?vue&type=template&id=01b47865&scoped=true&"
import script from "./article-table.vue?vue&type=script&lang=js&"
export * from "./article-table.vue?vue&type=script&lang=js&"
import style0 from "./article-table.vue?vue&type=style&index=0&id=01b47865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b47865",
  null
  
)

export default component.exports